import { ADD_TO_BUY_NOW, CLEAR_BUY_NOW } from '../actions/buyNowActions';

const initialState = {
  items: [],
};

export const buyNowReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_BUY_NOW:
      return {
        ...state,
        items: Array.isArray(action.payload)
          ? action.payload
          : [action.payload],
      };
    case CLEAR_BUY_NOW:
      return {
        ...state,
        items: [],
      };
    case "REMOVE_BUY_NOW_ITEM":
      return {
        ...state,
        items: state.items.filter(
          item => item.cart_id !== action?.payload?.cart_id
        )
      };
    default:
      return state;
  }
};